import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_fs_rec_4: FaireProductEntity = {
  token: "atc_updated_fs_rec_4",
  type: "product",
  name: "Forest Green Sculptural Side Table",
  brandName: "Faire Source",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2d565e2ca0a46337afa453991aac9d5296bd6febb0575cc3dbdb7ff91a711266.webp",
  priceDollars: 285,
  msrpDollars: 350,
  description: "Recommended product for ATC flow.",
  tags: ["home", "design", "recommendations"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
